import {
  FacebookCustomAudienceEventSourceType,
  FacebookCustomAudienceFilter,
  FacebookCustomAudienceOperator,
  FacebookCustomAudienceRule,
  FacebookCustomAudienceRuleSet,
} from '../Rule';

export interface WebsiteAudienceRule extends FacebookCustomAudienceRule {
  inclusions: {
    operator: FacebookCustomAudienceOperator;
    rules: [
      {
        event_sources: [
          {
            id: string;
            type: FacebookCustomAudienceEventSourceType.PIXEL;
          },
        ];
        filter?: FacebookCustomAudienceFilter;
        retention_seconds?: number;
        template?: string;
      },
      ...FacebookCustomAudienceRuleSet[]
    ];
  };
}

export const exampleWebsiteAudienceRule: WebsiteAudienceRule = {
  inclusions: {
    operator: 'or',
    rules: [
      {
        event_sources: [
          {
            type: FacebookCustomAudienceEventSourceType.PIXEL,
            id: '123',
          },
        ],
        retention_seconds: 2592000,
      },
    ],
  },
};
